import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@material-ui/core';
export function Logo(props) {
    return _jsx(Box, Object.assign({ component: "img", alt: "logo", src: "/static/brand/logo_single.svg", height: 40 }, props), void 0);
}
//# sourceMappingURL=Logo.js.map